import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { register, load, getInstances } from '@shopify/theme-sections';
Avatar.theme = Avatar.theme || {};
Avatar.theme.sections = Avatar.theme.sections || {};
var sectionName = 'announcement-bar';

Avatar.theme.sections.AnnouncementBar = function AnnouncementBar() {
  var selectors = {
    announcementContent: '[data-announcement-bar-content]',
    announcementClose: '[data-announcement-bar-close]'
  };
  var classes = {
    closeHeight: 'tw-max-h-0',
    invisible: 'tw-invisible',
    pointerNone: 'tw-pointer-events-none'
  };
  register(sectionName, {
    onLoad: function onLoad() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var container;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                container = _this.container;
                _this.announcementContainer = container;
                _this.announcementContent = container.querySelector(selectors.announcementContent);
                _this.announcementClose = container.querySelector(selectors.announcementClose);
                _this.eventHandlers = {};
                _this.settings = {};

                if (_this.announcementContainer) {
                  _this.getSettings();
                }

                if (_this.settings.dismiss) {
                  _this.eventHandlers.handleCloseClick = _this.handleCloseClick.bind(_this);

                  _this.announcementClose.addEventListener('click', _this.eventHandlers.handleCloseClick);
                }

                if (_this.settings.autoDismiss) {
                  _this.autoClose(_this.settings.delay);
                }

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getSettings: function getSettings() {
      this.settings = JSON.parse(this.announcementContainer.getAttribute('data-announcement-settings'));
      return this.settings;
    },
    handleCloseClick: function handleCloseClick(evt) {
      evt.preventDefault();
      this.closeAnnouncementBar();
      evt.currentTarget.blur();
    },
    closeAnnouncementBar: function closeAnnouncementBar() {
      var regex = new RegExp('(..:)?tw-max-h-..', 'g');
      var newClasses = this.announcementContainer.className.replace(regex, '-');
      this.announcementContainer.className = newClasses;
      this.announcementContainer.classList.add(classes.closeHeight);
      this.announcementContent.classList.add(classes.invisible);
      this.announcementContent.classList.add(classes.pointerNone);

      if (this.announcementClose) {
        this.announcementClose.classList.add(classes.invisible);
        this.announcementClose.classList.add(classes.pointerNone);
      }
    },
    autoClose: function autoClose(delay) {
      var _this2 = this;

      document.addEventListener('readystatechange', function (evt) {
        if (evt.target.readyState === 'complete') {
          setTimeout(function () {
            _this2.closeAnnouncementBar();
          }, delay);
        }
      });
    },
    onUnload: function onUnload() {
      this.announcementClose.removeEventListener('click', this.eventHandlers.handleCloseClick);
    }
  });
  load(sectionName);
  var instances = getInstances(sectionName);
  var instance = instances[0];

  function destroy() {
    instance.announcementClose.removeEventListener('click', instance.eventHandlers.handleCloseClick);
  }

  return {
    instance: instance,
    destroy: destroy
  };
}();